"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = orderMultilang;

var _orderMultiprice = _interopRequireDefault(require("./orderMultiprice"));

/**
 * Order field generation helper.
 *
 * Signature: `orderMultilang(options, fieldName, locale)`
 *
 * @param {Object} [options]
 * @param {string} [options.prefix='__order__']
 * @param {Function} [options.partsBuilder] Function that gets fieldName and locale and returns assembled string.
 * @param {Function} [options.assembler] Function that joins prefix and parts.
 * @param {string} fieldName
 * @param {string} locale
 *
 * @returns {string} String in format `${prefix}${fieldName}_${locale}`
 */
function orderMultilang(options, fieldName, locale) {
  return (0, _orderMultiprice.default)(options, fieldName, null, locale);
}